import {
  fetchPremiumUpgradeProduct,
  getPremiumUpgradeProductId,
} from './premiumUpgrade';

/* The cart line for a recurring add-on carries its ongoing price, not the first
   month's — firstMonthCost lives on the product record, which the cart does not
   return. Start Membership has the same gap and fetches the product to fill it.

   Returns the entry to merge into a known map, or null when there is nothing to
   add: no configured product, one already read, or that product not in the
   cart. Shared so the drawer and the checkout page cannot price the same line
   differently, which is what they did — FREE in one, $12.99 in the other, over
   one cart.

   Its own module rather than premiumUpgrade's: the drawer's test mocks that one
   wholesale, and composing here leaves the composition real under it. */
export const readFirstMonthPrices = async (cartInfo, known = {}) => {
  const upgradeId = getPremiumUpgradeProductId();
  if (!upgradeId || known[upgradeId] !== undefined) return null;

  const inCart = (cartInfo?.productsAndDetails || []).some(
    (entry) => entry?.product?._id === upgradeId,
  );
  if (!inCart) return null;

  const upgrade = await fetchPremiumUpgradeProduct();
  const firstMonthCost = upgrade?.ownPromoData?.firstMonthCost;
  return firstMonthCost == null ? null : { [upgradeId]: firstMonthCost };
};

export default { readFirstMonthPrices };
